const JUNK_CLASS_RE = /^(mso|apple-|webkit-)/i
const VALID_CLASS_RE = /^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$/
const HEADING_ID_RE = /^[A-Za-z][A-Za-z0-9_-]*$/

export function sanitizeClassName(value: unknown): string | null {
  if (typeof value !== 'string' || !value.trim()) {
    return null
  }
  const kept = value.split(/\s+/).filter((token) => {
    return VALID_CLASS_RE.test(token) && !JUNK_CLASS_RE.test(token)
  })
  return kept.length ? kept.join(' ') : null
}

export function sanitizeHeadingId(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null
  }
  const id = value.trim()
  return HEADING_ID_RE.test(id) ? id : null
}
